import React from 'react'

function Crm() {
    return (
        <>
            <head>
                <title>نظام CRM</title>
                <meta name="description" content="مع نظام إدارة علاقات العملاء (CRM) من بروتك، ستتمكن من:" />
            </head>
            <div>
                <h1>نظام CRM</h1>
                <p>مع نظام إدارة علاقات العملاء (CRM) من بروتك، ستتمكن من:

                </p>
                <ol>
                    <li> تخزين بيانات العملاء وتتبع تفاعلاتهم.</li>
                    <li>إدارة المبيعات وفرص العمل بشكل منظم.</li>
                    <li> أتمتة الرسائل والتسويق (Email & SMS).</li>
                </ol>
                <p>
                    🤝 حول عملاءك إلى شركاء نجاح!
                </p>
            </div>
        </>
    )
}

export default Crm